export default () => `
  <div class="content">
    Parapet height - the height from the top of the roof to the top of the wall around the roof edge. 
  </div>
`;
